import { StoreId } from "@ubnt/store.core/lib/types";

const prepareArrayForPath = (arr: string[]): string =>
  arr.map((el) => el.toLowerCase()).join("|");

export const REGIONAL_MICROSITE_PREFIX_PATH = `/:storeId(${prepareArrayForPath(
  Object.values(StoreId),
)})`;
